import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import useWidth from '../../../../../../../components/Hooks/useWidth';
import { resolveGroupHeaderTopSpacing } from '../../OrderProductGroupHeader/orderProductGroupHeader.utils';

interface OrderProductParentGroupPortalProps {
  container?: HTMLElement | null;
  children: ReactNode;
}

const OrderProductParentGroupPortal = ({
  container,
  children,
}: OrderProductParentGroupPortalProps) => {
  const { mediumDownWidth: isBelowDesktop } = useWidth();

  if (!container) {
    return children;
  }

  const subGroupTopSpacing = resolveGroupHeaderTopSpacing({
    hasTopSpacing: true,
    isSubGroup: true,
    isBelowDesktop,
  });

  return createPortal(<Box sx={{ mb: -subGroupTopSpacing }}>{children}</Box>, container);
};

export default OrderProductParentGroupPortal;
